/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * My Emissions API
 * We calculate food carbon footprints
 * OpenAPI spec version: 1.0.0 (v1)
 */

/**
 * * `product` - Product
* `sold_good` - Sold good
 */
export type RelatedItemTypeEnum = typeof RelatedItemTypeEnum[keyof typeof RelatedItemTypeEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelatedItemTypeEnum = {
  product: 'product',
  sold_good: 'sold_good',
} as const;
